import axios from "axios";

const baseAxios = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    serialize: (params) => {
      if (!params) return '';
      const parts: string[] = [];
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((v) => {
            parts.push(`${key}=${encodeURIComponent(v)}`);
          });
        } else if (value !== undefined && value !== null) {
          parts.push(`${key}=${encodeURIComponent(value)}`);
        }
      });
      return parts.join("&");
    },
  },
});

const getToken = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("token");
  }
  return null;
};

baseAxios.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

baseAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT";

      if (typeof window !== "undefined") {
        window.location.href = "/login";
      }
    }

    return {
      error: error.response?.data?.message || "Lỗi hệ thống",
    };
  }
);

export default baseAxios;
